import { reset } from './css/reset';
import './css/common.css'
import { Global, css } from '@emotion/react';
import { LangProvider } from './context/LangContext';
import { DeviceProvider } from './context/DeviceContext';
import { BrowserRouter as Router} from "react-router-dom";

import ScrollToTop from './ScrollToTop';
import { animateScroll as scroll } from 'react-scroll';

//import './css/fullPage.css'
//import {SectionsContainer, Section} from 'react-fullpage';

import DefaultSection from './components/DefaultSection';
import { useContext, useEffect, useState } from 'react';

const globalStyles = css`
  ${reset}

  html,
  body {
    margin: 0;
    padding: 0;
    height: 100vh;
    scrollbar-width: none;
    -ms-overflow-style: none;

    font-family: "Black Han Sans";
    background:#000000;
  }

  body::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera 스크롤바 숨김 */
  }

  .slick-slide {
      height: auto;
  }
  .slick-track {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: stretch;
  }

  .slick-slide img {    
    display: block;
    margin: auto;
}

`;

function App() {
  
  return (
    <DeviceProvider>
      <LangProvider>        
        {/* <Router>
            <ScrollToTop>
              <Global styles={globalStyles} />
              <Navbar/>
              <Routes>
                <Route path="/metodium" element={<Metodium />} />
                <Route path="/" element={
                  <>
                    <FixedMenu/>                    
                    <SectionsContainer {...options}>
                      <Section><Section1/></Section>
                      <Section><Section2/></Section>
                      <Section><Section3/></Section>
                      <Section><Section4/></Section>
                    </SectionsContainer>
                  </>
                }/>              
              </Routes>            
              <Footer/>
            </ScrollToTop>
        </Router> */}            
            <Router>
              <ScrollToTop>
              <Global styles={globalStyles} />
                <DefaultSection/>
              </ScrollToTop>
            </Router>
      </LangProvider>
    </DeviceProvider>
  );
}

export default App;
